import apiConfig from "@/configs/api-config";
import apiUtil from "@/utils/api-util";

// 隐私条款详情
const detail = (id, successCallback, failCallback) => {
    apiUtil.config(apiConfig.privacy_clause.detail, {
        id
    }).request().then(res => {
        if(res.error_code == apiConfig.errorCode.success) {
            successCallback(res.data);
        } else {
            failCallback(res.error_code, res.errorMsg);
        }
    })
}

export default {
    detail
}


// WEBPACK FOOTER //
// ./src/models/privacy-model.js